import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, renderSlot as _renderSlot, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["data-cy"]

import VInputCheckboxMultiState from "@/components/VInputCheckboxMultiState/VInputCheckboxMultiState.vue";
import { VIconSvg } from "@/components";
import { computed } from "vue";
import { kebabCase } from "lodash";

interface Props {
  isShownTableHeader: boolean;
  selectable: boolean;
  batchActionValue: string;
  data: Array<DataItem>;
  sortValue: {
    column: string;
    direction: string;
  };
}

interface DataItem {
  key: string;
  title?: string;
  thClass?: string;
  tdClass?: string;
  sortable?: boolean;
  field?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'THead',
  props: {
    isShownTableHeader: { type: Boolean },
    selectable: { type: Boolean },
    batchActionValue: {},
    data: {},
    sortValue: {}
  },
  emits: ["batchActionValue", "sortValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const batchActionValue = computed({
  get() {
    return props.batchActionValue;
  },
  set(value) {
    emit("batchActionValue", value);
  },
});

const batchActionOptions = computed(() => {
  const options = [
    {
      code: "selectedNone",
    },
    {
      code: "selectedPartly",
      icon: {
        name: "Dash",
        colorTag: "fill",
      },
    },
    {
      code: "selectedAll",
      icon: {
        name: "Check",
        colorTag: "stroke",
      },
    },
  ];

  return options.filter((item) => {
    let value = true;

    if (item.code === "selectedPartly") {
      value = props.batchActionValue === "selectedPartly";
    }

    return value;
  });
});

const getThClasses = (item: DataItem) => {
  return [item.thClass, `${item.key}-th`];
};

const getTitleClasses = (item: DataItem) => {
  const column = item.field ? item.field : item.key;
  const isSelectedColumn = props.sortValue.column === column;

  const sort = {
    "column-sort": item.sortable,
    "column-sort-active": isSelectedColumn,
    "column-sort-icon-rotate": isSelectedColumn && props.sortValue.direction === "desc",
  };

  return [`${item.key}-title`, sort];
};

const onClickTitle = (item: DataItem) => {
  return () => {
    if (item.sortable) {
      const column = item.field ? item.field : item.key;

      const sortValue = {
        column,
        direction:
          props.sortValue.direction === "desc"
            ? "asc"
            : props.sortValue.column === column
            ? "desc"
            : "asc",
      };

      emit("sortValue", sortValue);
    }
  };
};

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", null, [
      (props.selectable)
        ? (_openBlock(), _createElementBlock("th", _hoisted_1, [
            _createVNode(VInputCheckboxMultiState, {
              modelValue: batchActionValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((batchActionValue).value = $event)),
              options: batchActionOptions.value,
              "track-by": "code"
            }, null, 8, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item, index) => {
        return (_openBlock(), _createElementBlock("th", {
          key: index,
          class: _normalizeClass(getThClasses(item)),
          "data-cy": `table-thead-th-${_unref(kebabCase)(item.key)}`
        }, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["title", getTitleClasses(item)])
          }, [
            _renderSlot(_ctx.$slots, `title-${item.key}`, {
              title: item.title
            }),
            (item.sortable)
              ? (_openBlock(), _createBlock(_unref(VIconSvg), {
                  key: 0,
                  name: "ArrowDropdown",
                  size: "xs",
                  color: "fc-subduet",
                  "color-tag": "fill",
                  class: "sort-icon"
                }))
              : _createCommentVNode("", true)
          ], 2)), [
            [_directive_touch, onClickTitle(item)]
          ])
        ], 10, _hoisted_2))
      }), 128))
    ])
  ], 512)), [
    [_vShow, props.isShownTableHeader]
  ])
}
}

})